


export function AxisLabel({tickVal, translation, rotation, tickFormattingFunction} : {tickVal: number, tickFormattingFunction : (tickVal: number) => string, translation?: {x?: number, y?: number}, rotation?: number}  ) {

    return (
        <text
            className="text-xs"
            text-anchor="end"
            fill={'#C0C0BB'}
            transform={`translate(${translation?.x || 0}, ${translation?.y || 0}) rotate(${rotation || 0})`}
        >{tickFormattingFunction(tickVal)}</text>
    )

}

export const AxisTick = ({orientation}: {orientation: 'horizontal' | 'vertical'}) => {

    return (
        <line y2={orientation == 'vertical' ? - 6 : 0} x2={orientation == 'horizontal' ? - 6 : 0 } stroke={'#C0C0BB'}/>
    )
} 
